import React from 'react';
import styled from 'styled-components';
import { media, hover } from '@peloton/styles';
import { gray1, slate2 } from '@engage/colors';
import { spaces } from '@engage/styles';
import { sharedButtonStyles } from '@members/buttons';
import FilterButtonContent from './FilterButtonContent';

const StyledButton = styled.button`
  ${sharedButtonStyles}

  bottom: 24px;
  left: 50%;
  box-shadow: 0 0 20px 0;
  height: 40px;
  margin-left: -${spaces.giant}px;
  width: 160px;
  position: fixed;
  border-radius: 20px;
  background-color: ${gray1};
  color: ${slate2};
  stroke: ${slate2};

  ${media.tablet`
    display: none;
  `}

  &:active {
    filter: brightness(85%);
  }

  ${hover`filter: brightness(85%);`}
`;

type Props = {
  appliedFilterCount: number;
  toggle(): void;
};

export const MobileFilterButton: React.FC<React.PropsWithChildren<Props>> = ({
  toggle,
  appliedFilterCount,
}) => (
  <StyledButton onClick={toggle} data-test-id="mobileFilterButton">
    <FilterButtonContent appliedFilterCount={appliedFilterCount} />
  </StyledButton>
);
